<template>
    <div>
        <base-header class="pb-6 pb-8 pt-6 pt-md-6" type="gray-100">
          
        </base-header>

           <template v-if="loading">
                <div class="m-2">
                <skeleton altura="100px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
            </template>

            <template v-if="loading">
                <div class="m-2">
                <skeleton altura="400px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
            </template>

        <div class="container-fluid mt--7" v-if="!loading">
            <div class="row">
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">

                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img src="img/no-image/user.png" class="rounded-circle">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">

                        </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                                        <div>
                                            <span class="heading">22</span>
                                            <span class="description">Info X</span>
                                        </div>
                                        <div>
                                            <span class="heading">10</span>
                                            <span class="description">Info Y</span>
                                        </div>
                                        <div>
                                            <span class="heading">89</span>
                                            <span class="description">Info Z</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <h3  v-if="tipo == 'lab'">
                                    {{model.nomeFantasia}}
                                </h3 >
                                <div class="h5 font-weight-300"  v-if="tipo == 'lab'">
                                    {{model.razaoSocial}}
                                </div>
                                 <h3  v-if="tipo == 'den'">
                                    {{model.nome}}
                                </h3 >
                                <div class="h5 mt-4">
                                    <span class="font-weight-normal">Cadastro desde: </span>{{ formatarData(model.created_at) }}
                                </div>
                                <hr class="my-4" />
                                 <div class="gray-300" style="background-color: #f6f9fc; padding: 20px; ">
                                        <base-input alternative=""
                                                    label="Atualizar Senha"
                                                    input-classes="form-control-alternative"
                                                    v-model="model.senha"
                                                    placeholder="Em branco, para manter a mesma"
                                        />

                                </div>

                                <div class="mt-4">
                                  <base-button
                                    type="success"
                                    @click="salvar(1)"
                                    v-html="txt1"
                                    ></base-button>

                                     <base-button
                                    type="warning"
                                    @click="salvar(0)"
                                    v-html="txt2"
                                    ></base-button>

                                </div>

                                 <div class="mt-4">
                                    <div v-if="hasError" style="border: 2px solid #d83a3a; color: #d83a3a; border-radius: 5px; padding: 10px; text-transform: uppercase; font-size: 12px">
                                        Houve um erro ao salvar o usuário! Verifique os campos.
                                    </div>

                                     <div v-if="hasSuccess" style="border: 2px solid #4fbf1b; color: #4fbf1b; border-radius: 5px; padding: 10px; text-transform: uppercase; font-size: 12px">
                                        Usuário salvo com sucesso!
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-8 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Detalhes de Usuário</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <h6 class="heading-small text-muted mb-4">Informações Gerais</h6>
                                <div class="pl-lg-4" v-if="tipo == 'lab'">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="CNPJ"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.cnpj"
                                                        mask="##.###.###/####-##"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Razão Social"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.razaoSocial"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Nome Fantasia"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.nomeFantasia"
                                            />
                                        </div>
                                    </div>
                                   
                                </div>
                                <div class="pl-lg-4" v-if="tipo == 'den'">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <base-input alternative=""
                                                        label="CPF"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.cpf"
                                                        mask="###.###.###-##"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-8">
                                            <base-input alternative=""
                                                        label="Nome Completo"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.nome"
                                            />
                                        </div>
                                    </div>
                                     <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="CRO"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.cro"
                                            />
                                        </div>
                                        <div class="col-lg-2">
                                            <base-input alternative=""
                                                        label="CRO UF"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.croUf"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <h6 class="heading-small text-muted mb-4  mt-6">Dados de Contato</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="E-mail"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.email"
                                                        
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Telefone"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.celular"
                                                        mask="(0##) #####-####"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Responsável -->
                                <h6 class="heading-small text-muted mb-4  mt-6"  v-if="tipo == 'lab'">Dados do Responsável</h6>
                                <div class="pl-lg-4"  v-if="tipo == 'lab'">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="CPF"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.cpfResponsavel"
                                                        mask="###.###.###-##"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Nome Completo"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.nomeResponsavel"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="CRO"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.croResponsavel"
                                            />
                                        </div>
                                        <div class="col-lg-2">
                                            <base-input alternative=""
                                                        label="CRO UF"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.croUfResponsavel"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <!-- Address -->
                                <h6 class="heading-small text-muted mt-6 mb-4">Dados de Endereço</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                       <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="CEP"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.cep"
                                                        mask="#####-###"
                                                    
                                            />
                                        </div>
                                        <div class="col-lg-8">
                                            <base-input alternative=""
                                                        label="Logradouro"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.logradouro"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2">
                                            <base-input alternative=""
                                                        label="Número"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.numero"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Complemento"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.complemento"
                                            />
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Bairro"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.bairro"
                                            />
                                        </div>
                                    </div>
                                     <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Cidade"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.cidade"
                                            />
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Estado"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.estado"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                            
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import usuarios from '@/cflow/usuarios.js'
import cep from "@/cflow/cep.js";
  //import parametros from "@/cflow/parametros.js";
  import BaseButton from '../../components/BaseButton.vue';
  import BaseInput from '../../components/BaseInput.vue';
  //import Multiselect from "vue-multiselect";
  //import storage from 'storage';
  export default {
    name: 'tables',
    components: {
      //Multiselect,
      BaseButton,
      BaseInput
    },
    
    methods: {
        salvar: function(flag) {
            const _this = this;
            let form = _this.model;
            let tipo = _this.tipo;
            let id = _this.id;

            _this.loading = true;

            usuarios.salvar(tipo, id, flag, form).then(res => {
                if(res) {
                    _this.loading = false;
                    _this.hasSuccess = true;
                    setTimeout(function(){
                        _this.hasSuccess = false;
                    },5000);
                } else {
                    hasError(res)
                }
            }).catch((error) => {
                hasError(error)
            });

            function hasError(error) {
                console.err('ERROR', error)
                _this.loading = false;
                _this.hasError = true;
                 setTimeout(function(){
                    _this.hasError = false;
                },5000);
            }
        }
    },
    data() {
      return {
        txt1: 'Salvar e Ativar',
        txt2: 'Salvar e Inativar',
        tipo: null,
        id: null,
        status: [{'nome': 'Ativo', 'valor': 1}, {'nome': 'Inativo', 'valor': 0}],
        hasSuccess: false,
        hasError: false,
        loading: false,
        model: {
          id: '',
          cnpj: '',
          razaoSocial: '',
          nomeFantasia: '',
          email: '',
          senha: '',
          celular: '',
          cpfResponsável: '',
          nomeResponsável: '',
          croResponsavel: '',
          croUfResponsavel: '',
          cidade: '',
          bairro: '',
          logradouro: '',
          numero: '',
          complemento: '',
          estado: '',
          cep: '',
          site: '',
          ativo: 0
        }
      }
    },
    watch: {

        'model.cep': function (value) {
            if(value.length == 9) {
                cep.buscar(value.replace("-", "")).then((res) => {
                    this.model.estado = res.uf;
                    this.model.cidade = res.localidade;
                    this.model.bairro = res.bairro;
                    this.model.logradouro = res.logradouro;
                    this.model.estado = res.uf;
                });
            }     
        }
    },
    
     mounted(){
      //this.initLoad(0, 0);
      const _tipo = this.$route.params.tipo;
      const _id = this.$route.params.id;
      if(!_tipo || !_id) return;

      this.tipo = _tipo;
      this.id = _id;

      this.loading = true;

    usuarios.detalhes(_tipo, _id).then((res) => {
        this.model = res;
        this.loading = false;
    });

    }
  };
</script>
<style></style>
